module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-07 at 3.31.26 PM.51c70f97.png";